__turbopack_context__.v({
  "container": "ad78IG_container",
  "header": "ad78IG_header",
  "notes": "ad78IG_notes",
});
